import { StorageService } from './../../../services/storage/storage.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PredefinedTemplatesService } from '../../../services/edit/predefined-templates.service';
import { EmailService } from '../../side-nav/email/email.service';
import { SharedService } from '../../../services/shared/shared.service';

export interface FeedInterface {
  typeOf: string;
  title: string;
  background: string;
  color: string;
  flushed: boolean;
  className: string;
  enableReset: boolean;
  emailCheckbox: boolean;
  inputColor: string;
  inputBack: string;
  labelColor: string;
  sendEmail: string;
  replyOption: string;
  subjectLine: string;
  optionalTxt: string;
  name: boolean;
  email: string;
  sendButton: string;
  btnClass: string;
  resetButton: boolean;
  placeholder: string;
  emailOptional: boolean;
  phone: boolean;
}

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  @Input() feed: FeedInterface;
  @Output() editClicked = new EventEmitter<any>();

  feedbackType: any = null;
  userName: any;
  userPhone: any;

  private _checked = true;
  private _color: any = '#454545';
  private _background: any = 'transparent';

  constructor(
    private _emailService: EmailService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
  ) {}

  ngOnInit() {
    this.feed.labelColor = '#000';
  }

  getFEEDStyles() {
    const result = {
      color: this.feed.color ? this.feed.color : this._color,
      'background-color': this.feed.background ? this.feed.background : this._background,
    };
    return result;
  }
  toggleEmail() {
    this._checked = !this._checked;
  }
  onEdit() {
    this.editClicked.emit('New desciption');
  }
  resetForm(form: NgForm) {
    form.resetForm();
  }
  submitFeedback(form: NgForm) {
    // let email = form.form.controls;
    let message = '';
    let keepGoing = true;
    let isMultiple = false;
    let email_arr = [];
    let body = {};
    // build the body.
    const nameregex = /\S/;
    // let emailregex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
    const emailregex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i; // eslint-disable-line
    // let telregex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    // https://stackoverflow.com/questions/18375929/validate-phone-number-using-javascript
    const telregex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    if (!this.feed.sendEmail || !/\S/.test(this.feed.sendEmail)) {
      keepGoing = false;
      message = 'Send to Email Address is not configured, please reconfigure the widget';
      this._sharedService.openSnackBar(message, 'ok');
    }

    if (keepGoing) {
      if (/\S/.test(this.feed.sendEmail)) {
        //
        // multiple emails
        //
        if (this.feed.sendEmail.includes(',')) {
          isMultiple = true;
          email_arr = this.feed.sendEmail.split(',');
          if (email_arr.length <= 0) {
            keepGoing = false;
            message = 'Send to Email Address is not configured, please reconfigure the widget';
            this._sharedService.openSnackBar(message, 'ok');
          }
        }
      }
    }

    if (keepGoing) {
      // if name exists the ask user to add a valid name
      if (this.feed.name) {
        if (!nameregex.test(form.form.value.name)) {
          keepGoing = false;
          message += 'Please enter name field;';
        }
      }
    }

    if (keepGoing) {
      // if email box exits then ask user to enter a valid email address
      if (this.feed.email) {
        const regexresult = emailregex.test(form.form.value.email);
        if (!regexresult) {
          keepGoing = false;
          message += 'Please enter a valid email address;';
        }
      }
    }

    if (keepGoing) {
      if (form.form.value.option == null) {
        keepGoing = false;
        message += 'Please select a valid option for message;';
      } else {
        if (/\S/.test(form.form.value.description) === false) {
          keepGoing = false;
          message += 'add description';
        }
      }
    }

    // if phone box exits then ask user to enter a valid email address
    if (message !== '') {
      this._sharedService.openSnackBar(message, 'ok');
    }

    if (keepGoing) {
      const lid = this._storageService.getLid();
      const toEmail = `no-reply-feedback-${lid.toUpperCase()}@librarycard.com`;
      //
      //
      // generated a body in a particular format and the send it as MessageBody in email
      //
      let messageBody = 'Feedback Type : ' + form.form.value.option + '\r\n';
      messageBody += 'Feedback : ' + form.form.value.description + '\r\n';
      if (this.feed.emailCheckbox) {
        messageBody += 'Reply Requested : ' + (form.form.value.replyEmail ? 'Yes' : 'No') + '\r\n';
      }
      if (this.feed.name) {
        messageBody += 'Name : ' + form.form.value.name + '\r\n';
      }
      if (this.feed.phone) {
        messageBody += 'Phone : ' + form.form.value.phone + '\r\n';
      }
      if (this.feed.email) {
        messageBody += 'Email : ' + form.form.value.email + '\r\n';
      }
      if (this.feed.optionalTxt) {
        messageBody += '\r\n' + this.feed.optionalTxt + '\r\n';
      }

      //
      //  SINGLE EMAIL
      //

      if (!isMultiple) {
        body = {
          FromAddress: toEmail ? toEmail : '', // this is hardcoded
          FromAddressName: this.feed.name ? form.form.value.name : '',
          ToAddress: this.feed.sendEmail,
          CCAddress: '',
          BCCAddress: '',
          Subject: this.feed.subjectLine
            ? this.feed.subjectLine
            : form.form.value.option
              ? form.form.value.option
              : '',
          MessageBody: messageBody,
          IsBodyHtml: true,
        };
        this._emailService.SendEmail(body).subscribe((response) => {
          if (response.status === '200 OK') {
            if (response.data) {
              this._sharedService.openSnackBar(response.data.msg, 'ok');
            }

            form.resetForm();
          }
        });
      } else if (isMultiple) {
        let count = 0;
        const totalEmails = email_arr.length;
        for (let index = 0; index < email_arr.length; index++) {
          const toEmail = email_arr[index];
          body = {
            FromAddress: toEmail ? toEmail : '', // this is hardcoded
            FromAddressName: this.feed.name ? form.form.value.name : '',
            ToAddress: toEmail ? toEmail.trim() : '',
            CCAddress: '',
            BCCAddress: '',
            Subject: this.feed.subjectLine
              ? this.feed.subjectLine
              : form.form.value.option
                ? form.form.value.option
                : '',
            MessageBody: messageBody,
            IsBodyHtml: true,
          };
          this._emailService.SendEmail(body).subscribe((response) => {
            if (response.status === '200 OK') {
              if (response.data) {
                count += 1;
                if (count === totalEmails) {
                  this._sharedService.openSnackBar(response.data.msg, 'ok');
                  form.resetForm();
                }
              }
            }
          });
        }
      }
    }
  }

  onSubmit(form: NgForm) {
    const formValue = form.value;
    if (isNaN(formValue.phone)) {
      this._sharedService.openSnackBar('Enter a valid Phone number', 'ok');
    } else if (formValue.email.includes('.com') && formValue.email.includes('@')) {
      const postBody = {
        cid: this._storageService.getCid(),
        lid: this._storageService.getLid(),
        name: formValue.name,
        phone: formValue.phone,
        description: formValue.description,
        option: formValue.option,
        email: formValue.email,
      };
      this._predefinedTemplatesService.postFeedBack(postBody).subscribe((response) => {
        if (response.status === '200 OK') {
          this._sharedService.openSnackBar(response.message, 'ok');
          form.resetForm();
        }
      });
    } else {
      this._sharedService.openSnackBar('enter a valid email address', 'ok');
    }
  }
}
